import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './UserSubscriptions.scss';
import CheckBoxGroup from '../../../../components/_molecules/CheckBoxGroup/CheckBoxGroup';
import { TEXT_FIELD_STATUS } from '../../../../utils/constants';
import { getFieldInitialState } from '../../../../utils/helpers';

const subscriptionsCheckName = 'subscriptions';

class UserSubscriptions extends Component {
  static propTypes = {
    updateProfile: PropTypes.func.isRequired,
    profile: PropTypes.shape({}).isRequired,
    emailSubscriptions: PropTypes.shape({}).isRequired,
    id: PropTypes.number.isRequired,
  }
  constructor() {
    super();
    this.fields = {};
  }
  state = {
    subscriptionsCheck: getFieldInitialState(undefined, undefined, ['moderation']),
  };

  componentWillMount() {
    if (Object.keys(this.props.emailSubscriptions).length) {
      const subscriptionsCheck = this.fillSubscriptions();
      this.setState(() => ({
        subscriptionsCheck,
      }));
    }
  }

  componentDidUpdate(prevProps) {
    const { id } = this.props;
    if (id !== prevProps.id) {
      const subscriptionsCheck = this.fillSubscriptions();
      this.setState(() => ({
        subscriptionsCheck,
      }));
    }
  }

  fillSubscriptions = () => {
    const subscriptionsCheck = { ...this.state.subscriptionsCheck };
    const { emailSubscriptions } = this.props;
    if (emailSubscriptions.news) subscriptionsCheck.value.push('news');
    if (emailSubscriptions.finance) subscriptionsCheck.value.push('finance');
    return subscriptionsCheck;
  }
  registerField = ({ name, validator }) => {
    this.fields[name] = {
      validator,
    };
  };

  fieldChangeHandler = ({ name, value }) => {
    const subscriptionsCheck = {
      ...this.state.subscriptionsCheck,
    };

    subscriptionsCheck.value = value;
    if (
      subscriptionsCheck.status !== TEXT_FIELD_STATUS.INITIAL &&
      !subscriptionsCheck.outerError
    ) {
      const { validator } = this.fields[name];
      const validate = validator(subscriptionsCheck.value);
      subscriptionsCheck.status = validate.status;
      subscriptionsCheck.errorText = validate.errorText;
    }
    this.setState(() => ({ subscriptionsCheck }), () => {
      const { profile, updateProfile } = this.props;
      const data = { ...profile };
      delete data.role;
      data.news = subscriptionsCheck.value.indexOf('news') > -1;
      data.finance = subscriptionsCheck.value.indexOf('finance') > -1;
      updateProfile(data);
    });
  };

  render() {
    const { subscriptionsCheck } = this.state;
    return (
      <div className="user-subscriptions">
        <div className="subscriptions-header">
          <span>Recieve emails from:</span>
        </div>
        <div className="checkbox-wrapper">
          <CheckBoxGroup
            registerField={this.registerField}

            changeHandler={this.fieldChangeHandler}
            values={['finance', 'moderation', 'news']}
            name={subscriptionsCheckName}
            status={subscriptionsCheck.status}
            value={subscriptionsCheck.value}

            disabled={['moderation']}
          >
            <span>Finance</span>
            <span>Moderation </span>
            <span>Advaice News</span>
          </CheckBoxGroup>
        </div>
      </div>
    );
  }
}

export default UserSubscriptions;



// WEBPACK FOOTER //
// ./src/containers/UserScreen/components/UserSubscriptions/UserSubscriptions.js